import { Outlet } from "react-router-dom";
import PublicNav from "@/components/layout/PublicNav";
import Footer from "@/components/layout/Footer";

export default function PublicLayout() {
    return (
        <div className="relative min-h-screen flex flex-col">
            <PublicNav />
            <main className="flex-1 relative z-10">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
